import React, { useState } from "react";

export const Image = ({ title, largeImage }) => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const openModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="portfolio-item" style={{ marginBottom: '30px' }}>
      <div style={{
        position: 'relative',
        borderRadius: '20px',
        overflow: 'hidden',
        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
        transition: 'all 0.4s ease',
        background: 'white'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-10px)';
        e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
      }}>
        
        {/* Indicador de carga */}
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              border: '4px solid #3498db',
              borderTop: '4px solid transparent',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
          </div>
        )}
        
        <div className="hover-bg" style={{ position: 'relative' }}>
          <a href="#" onClick={openModal} title={title} style={{ textDecoration: 'none' }}>
            {/* Overlay con gradiente */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(135deg, rgba(52, 152, 219, 0.8), rgba(46, 204, 113, 0.8))',
              opacity: 0,
              transition: 'opacity 0.4s ease',
              zIndex: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            className="image-overlay"
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0'}>
              
              <div style={{
                textAlign: 'center',
                color: 'white',
                transform: 'translateY(20px)',
                transition: 'transform 0.4s ease'
              }}
              className="hover-content"
              onMouseEnter={(e) => e.target.style.transform = 'translateY(0)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(20px)'}>
                <div style={{
                  fontSize: '3em',
                  marginBottom: '15px',
                  filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))'
                }}>🔍</div>
                <h4 style={{
                  fontSize: '1.4em',
                  fontWeight: 'bold',
                  margin: '0 0 10px 0',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                }}>{title}</h4>
                <p style={{
                  fontSize: '1em',
                  margin: 0,
                  opacity: 0.9
                }}>Click para ampliar</p>
              </div>
            </div>
            
            <img 
              src={largeImage} 
              className="img-responsive" 
              alt={title}
              onLoad={handleImageLoad}
              style={{ 
                width: "100%", 
                height: "280px", 
                objectFit: "cover",
                transition: 'transform 0.4s ease'
              }} 
            />
          </a>
        </div>
        
        {/* Título en la parte inferior */}
        <div style={{
          padding: '20px',
          background: 'white',
          textAlign: 'center'
        }}>
          <h5 style={{
            color: '#2c3e50',
            fontSize: '1.1em',
            fontWeight: 'bold',
            margin: 0
          }}>{title}</h5>
        </div>
      </div>

      {/* Modal mejorado */}
      {showModal && (
        <div 
          className="modal-overlay" 
          onClick={closeModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            animation: 'fadeIn 0.3s ease'
          }}
        >
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              maxWidth: "95%",
              maxHeight: "95%",
              animation: 'zoomIn 0.3s ease'
            }}
          >
            {/* Botón de cerrar mejorado */}
            <button 
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "-50px",
                right: "0",
                background: "rgba(255,255,255,0.2)",
                border: "2px solid white",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "white";
                e.target.style.color = "#2c3e50";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "rgba(255,255,255,0.2)";
                e.target.style.color = "white";
              }}
            >
              ×
            </button>
            
            <img 
              src={largeImage} 
              alt={title} 
              style={{
                maxWidth: "100%",
                maxHeight: "85vh",
                display: "block",
                margin: "0 auto",
                borderRadius: "15px",
                boxShadow: "0 25px 50px rgba(0, 0, 0, 0.5)",
              }} 
            />
            
            <div style={{
              textAlign: "center",
              color: "white",
              marginTop: "20px",
              padding: "15px",
              background: "rgba(0,0,0,0.5)",
              borderRadius: "10px",
              backdropFilter: "blur(10px)"
            }}>
              <h3 style={{
                fontSize: "1.5em",
                fontWeight: "bold",
                margin: "0 0 10px 0"
              }}>{title}</h3>
              <p style={{
                fontSize: "1em",
                opacity: 0.8,
                margin: 0
              }}>Presiona ESC o haz click fuera para cerrar</p>
            </div>
          </div>
        </div>
      )}
      
      {/* CSS para animaciones */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes zoomIn {
          from { transform: scale(0.8); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};
